module.exports = __webpack_public_path__ + "media/images/global/icons/microphone-00b3eb5db16796863678e0e803b9ff6b.svg";